import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const TimerIconWhite: React.FC<NormalIconProps> = ({ className }) => (
	<svg className={className} width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Time Circle">
			<path
				id="Stroke 1"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.2188 13.0005C25.2188 19.3867 20.0425 24.563 13.6562 24.563C7.27 24.563 2.09375 19.3867 2.09375 13.0005C2.09375 6.61424 7.27 1.43799 13.6562 1.43799C20.0425 1.43799 25.2188 6.61424 25.2188 13.0005Z"
				stroke="white"
				strokeWidth="2.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Stroke 3"
				d="M17.9454 16.6781L13.2329 13.8669V7.80811"
				stroke="white"
				strokeWidth="2.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
